import { render, staticRenderFns } from "./AIIvrForm.vue?vue&type=template&id=07e6a52a&scoped=true&"
import script from "./AIIvrForm.vue?vue&type=script&lang=js&"
export * from "./AIIvrForm.vue?vue&type=script&lang=js&"
import style0 from "./AIIvrForm.vue?vue&type=style&index=0&id=07e6a52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e6a52a",
  null
  
)

export default component.exports